import React from 'react';
import { IconCard } from "./";

const SearchList = ({ filteredIcons, changeIcon }) => {
    const filtered = filteredIcons.map((icon, index) => <IconCard key={index} icon={icon} changeIcon={changeIcon} />);

    return (
        <>
            {filtered}
        </>
    );
};

export { SearchList };